import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { get, find, isEmpty } from 'lodash';
import classnames from 'classnames';
import SeeCurrentDetails from './see-current-details';
import ReviewOfferHostView from './review-offer-host-view';
import ReviewOfferGuestView from './review-offer-guest-view';
import ModalManager from '../elements-modal/modal-manager-v2';
import CurrentDetailsContainer from '../app-main/containers/CurrentDetailsContainer';
import {
  normalizeContracts,
  priceBreakdownObject
} from '../app-bookings-request/forms/bookingUtil';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { BookingSummary } from '../elements-summaries/booking-summary/BookingSummary';

export default class ReviewOfferDetailsMain extends Component {
  componentDidMount() {
    const { contract, isHost, displayGenericError } = this.props;
    if (!isHost) {
      const pendingContractData = get(contract, 'data.pending', []);
      const contractData = !isEmpty(pendingContractData)
        ? pendingContractData
        : get(contract, 'data.contracts', []);
      const spaceRental = find(contractData, { type: 'SPACE_RENTAL' }) || {};
      const spaceRentalBooking = get(spaceRental, 'meta.booking', {});
      spaceRentalBooking.listing = get(spaceRental, 'meta.listing', {});

      analyticsIntegrations.reviewCustomOfferFormViewed(
        spaceRentalBooking,
        contractData
      );

      if (displayGenericError) {
        this.setState({
          displayError: this.props.intl.formatMessage({
            id: 'inbox_review_offer.review_offer_form.something_wrong',
            defaultMessage: 'Something went wrong, please try again.'
          })
        });
      }
    }
  }

  render() {
    const {
      booking = {},
      profile = {},
      handleWithdrawOfferClick = null,
      redirectToInboxDetails = null,
      isSubmitting = false,
      isHost = true,
      accessToken = '',
      acceptOfferAction = null,
      declineOfferAction = null,
      contract = {},
      withdrawOffer = null,
      errorMessage = '',
      bookingId = '',
      routeParams = {},
      toggleModal = null,
      whichModal = '',
      paymentErrorMsg = '',
      iosWebView = false,
      scrollTopIOS = null,
      closeIOSModal = null,
      finalCb = null,
      checkCCState,
      feeProfiles = {},
      genericError,
      allCountries = [],
      globalCountries = [],
      spaces,
      dispatch,
      showBillingForm,
      billingCountryValue,
      billingStateValue,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue,
      intl
    } = this.props;

    const snapshotContracts = get(contract, 'data.contracts');
    const snapshotPending = get(contract, 'data.pending');
    const pendingMasterContract =
      find(snapshotPending, { type: 'MASTER' }) || {};
    const currentContractMaster =
      find(snapshotContracts, { type: 'MASTER' }) || {};
    const currentContractTotal = get(
      currentContractMaster,
      'calculations.guest.payment',
      null
    );
    const currentBookingTotal = !isEmpty(currentContractMaster)
      ? currentContractTotal
      : get(booking, 'booking.guest_payment_amount');
    const isHostUpdate =
      'HOST_UPDATE_SUBMITTED' === pendingMasterContract.state ||
      'UPDATE_HOST_NO_AUTH' === pendingMasterContract.state;

    const snapshot = !isEmpty(snapshotPending)
      ? snapshotPending
      : snapshotContracts;
    const normalizedContracts = normalizeContracts(snapshot);
    const priceBreakdown = priceBreakdownObject(normalizedContracts);

    const socialEventPolicyAgreementRequired = get(
      normalizedContracts,
      'spaceRentalContract.meta.risk.guest_social_events_policy_agreement_required',
      false
    );

    const {
      cleaningFee,
      spaceRentalSubtotal,
      spaceRentalTotal,
      currency,
      currencySymbol,
      itemsArray,
      addOnsTotal,
      total,
      discounts,
      guestPayment,
      hostFee,
      guestFee,
      hostPayout,
      updateDifference,
      hostAddOnsSummary,
      guestSplitPaymentFee
    } = priceBreakdown;

    const masterContract = get(normalizedContracts, 'masterContract', {});
    const guestId = masterContract.guest_sso_id || null;
    const hostId = masterContract.host_sso_id || null;
    const isSplitPayment = get(
      currentContractMaster,
      'split_payment_checkout',
      false
    );

    const activityDetailBooking = { ...booking.booking };
    if (!isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = isHost ? 'HOST' : 'GUEST';
      activityDetailBooking.customOfferStep = 'review';
      activityDetailBooking.attendees = get(
        normalizedContracts,
        'bookingObject.number_of_guests',
        0
      );
      activityDetailBooking.spaceRental = spaceRentalTotal;
      activityDetailBooking.schedule = get(
        normalizedContracts,
        'bookingObject.schedule',
        []
      );
      if (isHost) {
        _.set(activityDetailBooking, 'guest.sso_id', guestId);
        delete activityDetailBooking.host;
      }
    }

    return (
      <SharedIntlProviderHOC>
        <div className='ReviewOfferDetailsMain'>
          {iosWebView && (
            <ModalManager whichModal={whichModal} toggleModal={toggleModal}>
              <div id='CurrentDetailsContainerModal'>
                <CurrentDetailsContainer
                  booking={booking}
                  accessToken={accessToken}
                  routeParams={routeParams}
                  iosWebView={iosWebView}
                  scrollTopIOS={scrollTopIOS}
                  toggleModal={toggleModal}
                  whichModal={whichModal}
                />
              </div>
            </ModalManager>
          )}

          <div
            className={classnames('ps-container-lg-margin ps-container-fixed', {
              none: 'CurrentDetailsContainerModal' === whichModal
            })}
          >
            <div className='ps-row'>
              <h3 className='col-xs-12 col-lg-6'>
                <FormattedMessage
                  id='inbox_review_offer.review_offer_details_main.review_offer'
                  defaultMessage='Review {offer}'
                  values={{
                    offer: !isHost ? (
                      <FormattedMessage
                        id='inbox_review_offer.review_offer_details_main.custom_offer'
                        defaultMessage='and book'
                      />
                    ) : (
                      ''
                    )
                  }}
                />
              </h3>
              <div className='col-xs-12 col-lg-6 invoice-number'>
                <FormattedMessage
                  id='inbox_review_offer.review_offer_details_main.invoice'
                  defaultMessage='Invoice # {id}'
                  values={{
                    id: masterContract.invoice_id
                  }}
                />
              </div>
            </div>

            <div className='ps-row'>
              <div className='col-xs-12 col-lg-8'>
                {isHost ? (
                  <ReviewOfferHostView
                    cleaningFee={cleaningFee}
                    currency={currency}
                    currencySymbol={currencySymbol}
                    handleWithdrawOfferClick={handleWithdrawOfferClick}
                    redirectToInboxDetails={redirectToInboxDetails}
                    isSubmitting={isSubmitting}
                    itemsArray={itemsArray}
                    addOnsTotal={addOnsTotal}
                    hostAddOnsSummary={hostAddOnsSummary}
                    total={total}
                    masterContract={masterContract}
                    hostFee={hostFee}
                    guestFee={guestFee}
                    hostPayout={hostPayout}
                    guestPayment={guestPayment}
                    hostId={hostId}
                    discounts={discounts}
                    contract={contract}
                    spaceRentalSubtotal={spaceRentalSubtotal}
                    spaceRentalTotal={spaceRentalTotal}
                    withdrawOffer={withdrawOffer}
                    errorMessage={errorMessage}
                    bookingId={bookingId}
                    isHostUpdate={isHostUpdate}
                    finalCb={finalCb}
                  />
                ) : (
                  <ReviewOfferGuestView
                    booking={booking.booking}
                    cleaningFee={cleaningFee}
                    currency={currency}
                    currencySymbol={currencySymbol}
                    itemsArray={itemsArray}
                    addOnsTotal={addOnsTotal}
                    subtotal={total[guestId] || 0}
                    total={guestPayment}
                    ssoId={profile.SSOid}
                    redirectToInboxDetails={redirectToInboxDetails}
                    accessToken={accessToken}
                    acceptOfferAction={acceptOfferAction}
                    declineOfferAction={declineOfferAction}
                    masterContract={masterContract}
                    contractBooking={normalizedContracts.bookingObject}
                    spaceRentalSubtotal={spaceRentalSubtotal}
                    spaceRentalTotal={spaceRentalTotal}
                    guestFee={guestFee}
                    discounts={discounts}
                    toggleModal={toggleModal}
                    whichModal={whichModal}
                    snapshotPending={snapshotPending}
                    iosWebView={iosWebView}
                    scrollTopIOS={scrollTopIOS}
                    closeIOSModal={closeIOSModal}
                    isHostUpdate={isHostUpdate}
                    updateDifference={updateDifference}
                    currentBookingTotal={currentBookingTotal}
                    routeParams={routeParams}
                    finalCb={finalCb}
                    contracts={snapshot}
                    checkCCState={checkCCState}
                    paymentErrorMsg={paymentErrorMsg}
                    socialEventPolicyAgreementRequired={
                      socialEventPolicyAgreementRequired
                    }
                    feeProfiles={feeProfiles}
                    genericError={genericError}
                    allCountries={allCountries}
                    globalCountries={globalCountries}
                    profile={profile}
                    spaces={spaces}
                    splitPaymentFee={guestSplitPaymentFee}
                    isSplitPayment={isSplitPayment}
                    showBillingForm={showBillingForm}
                    billingCountryValue={billingCountryValue}
                    billingStateValue={billingStateValue}
                    billingCityValue={billingCityValue}
                    billingStreetValue={billingStreetValue}
                    billingUnitValue={billingUnitValue}
                    billingZipValue={billingZipValue}
                    dispatch={dispatch}
                  />
                )}
              </div>
              <div className='activity-details col-xs-12 col-lg-4'>
                <BookingSummary
                  booking={activityDetailBooking}
                  profile={profile}
                  intl={intl}
                  iosWebViewConfig={{
                    iosWebView: iosWebView
                  }}
                />
                {!isEmpty(snapshotPending) && (
                  <SeeCurrentDetails
                    toggleModal={toggleModal}
                    iosWebView={iosWebView}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

ReviewOfferDetailsMain.contextTypes = {
  router: PropTypes.object
};

ReviewOfferDetailsMain.propTypes = {
  booking: PropTypes.object,
  profile: PropTypes.object,
  handleWithdrawOfferClick: PropTypes.func,
  redirectToInboxDetails: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isHost: PropTypes.bool,
  contract: PropTypes.object,
  accessToken: PropTypes.string,
  acceptOfferAction: PropTypes.func,
  declineOfferAction: PropTypes.func,
  iosWebView: PropTypes.bool,
  closeIOSModal: PropTypes.func,
  withdrawOffer: PropTypes.func,
  errorMessage: PropTypes.string,
  bookingId: PropTypes.string,
  routeParams: PropTypes.object,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  scrollTopIOS: PropTypes.func,
  finalCb: PropTypes.func,
  feeProfiles: PropTypes.obj
};
